import React from 'react';
import { Button } from 'react-bootstrap';

const OverLayInfoModal = ({ isOpen, onClose, title, children, buttonText = "Close" }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        {/* Header */}
        <h2 className="modal-title">{title}</h2>

        {/* Make modal-body scrollable */}
        <div
          className="modal-body"
          style={{
            textAlign: 'left',
            maxHeight: '60vh',
            overflowY: 'scroll',
            paddingTop: '0',
            paddingLeft: '0',
            paddingRight: '0',
            fontSize: '15px',
          }}
        >
          {children}
        </div>

        {/* Fixed Close button at the bottom */}
        <div className="modal-buttons">
          <Button variant="primary" onClick={onClose}>
            {buttonText}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default OverLayInfoModal;
